import { Storage } from './storage';
import { WorkflowStepCompletion } from './workflow-step-completion';


export enum WorkflowFileType {
    FILE_TYPE_NEW = 1,
    FILE_TYPE_ATTACHED = 2,
    FILE_TYPE_EXISTING = 3
}

export interface WorkflowFile {
    id?: number;
    name: string;
    description?: string;
    workflow_step_completion_id?: number;
    error?: any;

    attached_file_path?: string;
    attached_storage_id?: number;

    attached_storage?: Storage;

    file_type_id?: WorkflowFileType;
    
    is_duplicate_per_target?: boolean;
    
    // for execution
    isAdditional?: boolean;
}